export const eastAfricanCarData = {
  "Toyota": {
    models: [
      "Corolla", "Corolla Axio", "Corolla Fielder", "Corolla Spacio", "Corolla Runx",
      "Camry", "Camry Hybrid", "Avensis", "Mark II", "Mark X", "Crown", "Carina",
      "Vitz", "Platz", "Belta", "Ractis", "Yaris", "Aqua", "Prius", "Prius Alpha",
      "RAV4", "Harrier", "Kluger", "Highlander", "4Runner", "Fortuner", "Surf",
      "Land Cruiser", "Land Cruiser Prado", "Sequoia", "FJ Cruiser",
      "Hiace", "Quantum", "Coaster", "Dyna", "Hilux", "Tacoma", "Tundra",
      "Probox", "Succeed", "Caldina", "Wish", "Ipsum", "Picnic", "Estima",
      "Sienta", "Porte", "Spade", "Noah", "Voxy", "Esquire", "Alphard", "Vellfire",
      "C-HR", "Rush", "Raize", "Yaris Cross", "Corolla Cross"
    ],
    popular: ["Corolla", "Vitz", "Probox", "Hiace", "RAV4", "Prado", "Hilux"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Pickup", "Van", "Wagon", "Crossover"]
  },
  
  "Nissan": {
    models: [
      "Sunny", "Sentra", "Sylphy", "Bluebird", "Primera", "Maxima", "Teana", "Fuga",
      "March", "Note", "Tiida", "Wingroad", "AD Van", "Almera", "Versa",
      "X-Trail", "Murano", "Pathfinder", "Patrol", "Safari", "Terrano", "Juke",
      "Qashqai", "Rogue", "Armada", "Xterra", "Kicks", "Magnite",
      "Navara", "Frontier", "Titan", "Hardbody", "NP200", "NP300",
      "Urvan", "NV200", "Elgrand", "Serena", "Quest", "Caravan",
      "Cube", "Livina", "Lafesta", "Presage", "Bassara", "Liberty"
    ],
    popular: ["Sunny", "March", "X-Trail", "Navara", "Patrol", "Note"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Pickup", "Van", "Crossover"]
  },

  "Honda": {
    models: [
      "Civic", "Accord", "City", "Grace", "Insight", "Integra", "Prelude",
      "Fit", "Jazz", "Freed", "Shuttle", "Stream", "Airwave", "Mobilio",
      "CR-V", "HR-V", "Vezel", "Pilot", "Passport", "Element", "Ridgeline",
      "Stepwgn", "Odyssey", "Elysion", "CR-Z", "S2000", "NSX",
      "Acty", "Vamos", "Life", "Today", "Zest", "N-Box", "N-One", "N-WGN"
    ],
    popular: ["Fit", "Civic", "CR-V", "Freed", "Vezel", "Accord"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Crossover", "Van", "Coupe"]
  },

  "Mazda": {
    models: [
      "Mazda2", "Mazda3", "Mazda6", "Axela", "Atenza", "Familia", "Capella",
      "Demio", "Verisa", "Carol", "AZ-Wagon", "Flair", "CX-3", "CX-5", "CX-7",
      "CX-9", "Tribute", "MPV", "Premacy", "Biante", "CX-8", "Bongo",
      "BT-50", "B-Series", "RX-7", "RX-8", "MX-5", "Roadster"
    ],
    popular: ["Demio", "Axela", "Atenza", "CX-5", "Premacy", "Bongo"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Crossover", "Van", "Pickup", "Convertible"]
  },

  "Mitsubishi": {
    models: [
      "Lancer", "Galant", "Diamante", "Mirage", "Colt", "Space Star",
      "Outlander", "ASX", "Pajero", "Pajero Sport", "Montero", "Shogun",
      "L200", "Triton", "Strada", "Canter", "Fuso", "Delica", "Grandis",
      "Chariot", "RVR", "Eclipse", "3000GT", "GTO", "FTO", "Starion"
    ],
    popular: ["Lancer", "Outlander", "Pajero", "L200", "Canter", "RVR"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Pickup", "Van", "Coupe"]
  },

  "Subaru": {
    models: [
      "Impreza", "Legacy", "Outback", "Forester", "XV", "Crosstrek",
      "Tribeca", "Ascent", "WRX", "STI", "BRZ", "Justy", "Vivio",
      "Pleo", "R2", "Stella", "Sambar", "Domingo", "Levorg", "Exiga"
    ],
    popular: ["Impreza", "Forester", "Legacy", "Outback", "XV"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Crossover", "Wagon", "Coupe"]
  },

  "Suzuki": {
    models: [
      "Swift", "Baleno", "Ciaz", "Ertiga", "S-Cross", "Vitara", "Grand Vitara",
      "Jimny", "Samurai", "Sidekick", "XL7", "Forenza", "Reno", "SX4",
      "Kizashi", "Alto", "Celerio", "Wagon R", "Cultus", "Liana",
      "Aerio", "Escudo", "Carry", "Every", "APV", "Landy"
    ],
    popular: ["Swift", "Alto", "Vitara", "Jimny", "Ertiga", "Carry"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Crossover", "Van", "Pickup"]
  },

  "Isuzu": {
    models: [
      "D-Max", "KB Series", "Trooper", "Rodeo", "Amigo", "VehiCROSS",
      "Ascender", "Axiom", "i-Series", "NPR", "NQR", "FRR", "FVR",
      "Bighorn", "Wizard", "MU", "Gemini", "Stylus", "Impulse"
    ],
    popular: ["D-Max", "KB Series", "Trooper", "NPR", "FRR"],
    bodyTypes: ["Pickup", "SUV", "Commercial", "Truck"]
  },

  "Ford": {
    models: [
      "Focus", "Fiesta", "Fusion", "Mondeo", "Mustang", "Taurus",
      "EcoSport", "Kuga", "Edge", "Explorer", "Expedition", "Bronco",
      "F-150", "Ranger", "Transit", "Tourneo", "Galaxy", "S-Max",
      "Ka", "Puma", "Escort", "Sierra", "Cortina", "Laser", "Telstar"
    ],
    popular: ["Focus", "Fiesta", "Ranger", "EcoSport", "Transit"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Pickup", "Van", "Crossover"]
  },

  "Volkswagen": {
    models: [
      "Golf", "Polo", "Jetta", "Passat", "Arteon", "Beetle", "CC",
      "Tiguan", "Touareg", "Atlas", "ID.4", "Touran", "Sharan",
      "Caddy", "Transporter", "Crafter", "Amarok", "Up!", "Lupo",
      "Bora", "Vento", "Scirocco", "Eos", "Phaeton"
    ],
    popular: ["Golf", "Polo", "Passat", "Tiguan", "Amarok", "Transporter"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Pickup", "Van", "Crossover"]
  },

  "Mercedes-Benz": {
    models: [
      "A-Class", "B-Class", "C-Class", "E-Class", "S-Class", "CLA", "CLS",
      "GLA", "GLB", "GLC", "GLE", "GLS", "G-Class", "ML-Class", "GL-Class",
      "SL", "SLK", "SLC", "AMG GT", "Sprinter", "Vito", "Metris", "Viano",
      "V-Class", "X-Class", "190E", "W123", "W124", "W126", "W140"
    ],
    popular: ["C-Class", "E-Class", "GLC", "Sprinter", "Vito"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Van", "Convertible", "Coupe"]
  },

  "BMW": {
    models: [
      "1 Series", "2 Series", "3 Series", "4 Series", "5 Series", "6 Series", "7 Series", "8 Series",
      "X1", "X2", "X3", "X4", "X5", "X6", "X7", "Z3", "Z4", "Z8",
      "i3", "i8", "iX3", "iX", "i4", "M2", "M3", "M4", "M5", "M6", "M8",
      "X5 M", "X6 M", "Mini Cooper", "Mini Countryman", "Mini Clubman"
    ],
    popular: ["3 Series", "5 Series", "X3", "X5", "1 Series"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Convertible", "Coupe"]
  },

  "Audi": {
    models: [
      "A1", "A3", "A4", "A5", "A6", "A7", "A8", "TT", "R8",
      "Q2", "Q3", "Q5", "Q7", "Q8", "e-tron", "RS3", "RS4", "RS5", "RS6", "RS7",
      "S3", "S4", "S5", "S6", "S7", "S8", "100", "80", "90", "V8"
    ],
    popular: ["A3", "A4", "Q3", "Q5", "A6"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Convertible", "Coupe"]
  },

  "Hyundai": {
    models: [
      "Accent", "Elantra", "Sonata", "Azera", "Genesis", "Veloster",
      "Tucson", "Santa Fe", "Palisade", "Kona", "Venue", "Nexo",
      "i10", "i20", "i30", "i40", "ix35", "ix55", "H1", "H100",
      "Porter", "Mighty", "County", "Universe", "Starex", "Grand Starex"
    ],
    popular: ["Accent", "Elantra", "Tucson", "Santa Fe", "i10", "H1"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Van", "Pickup", "Bus"]
  },

  "Kia": {
    models: [
      "Rio", "Forte", "Optima", "Cadenza", "Stinger", "Soul",
      "Sportage", "Sorento", "Telluride", "Seltos", "Niro", "EV6",
      "Picanto", "Cerato", "Magentis", "Opirus", "Carnival", "Sedona",
      "Pregio", "Bongo", "K-Series", "Frontier", "Retona", "Mohave"
    ],
    popular: ["Rio", "Sportage", "Sorento", "Picanto", "Cerato", "Pregio"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Van", "Crossover"]
  },

  "Peugeot": {
    models: [
      "106", "107", "108", "206", "207", "208", "306", "307", "308",
      "406", "407", "408", "508", "605", "607", "807", "1007", "2008",
      "3008", "5008", "Partner", "Expert", "Boxer", "Bipper", "Rifter"
    ],
    popular: ["206", "207", "307", "3008", "Partner"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Van", "Crossover"]
  },

  "Renault": {
    models: [
      "Clio", "Megane", "Laguna", "Scenic", "Espace", "Captur", "Kadjar",
      "Koleos", "Duster", "Kwid", "Logan", "Sandero", "Symbol",
      "Kangoo", "Trafic", "Master", "Twingo", "Wind", "Fluence"
    ],
    popular: ["Clio", "Megane", "Duster", "Kangoo", "Logan"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Van", "Crossover"]
  },

  "Land Rover": {
    models: [
      "Defender", "Discovery", "Discovery Sport", "Range Rover", "Range Rover Sport",
      "Range Rover Evoque", "Range Rover Velar", "Freelander", "LR2", "LR3", "LR4",
      "Series I", "Series II", "Series III", "County", "Ninety", "One Ten"
    ],
    popular: ["Defender", "Discovery", "Range Rover", "Freelander"],
    bodyTypes: ["SUV", "Pickup"]
  },

  "Jeep": {
    models: [
      "Wrangler", "Cherokee", "Grand Cherokee", "Compass", "Patriot",
      "Renegade", "Gladiator", "Commander", "Liberty", "CJ Series",
      "Scrambler", "Wagoneer", "Grand Wagoneer"
    ],
    popular: ["Wrangler", "Cherokee", "Grand Cherokee", "Compass"],
    bodyTypes: ["SUV", "Pickup"]
  },

  "Chevrolet": {
    models: [
      "Spark", "Sonic", "Cruze", "Malibu", "Impala", "Camaro", "Corvette",
      "Trax", "Equinox", "Traverse", "Tahoe", "Suburban", "Silverado",
      "Colorado", "Captiva", "Aveo", "Epica", "Lacetti", "Matiz"
    ],
    popular: ["Cruze", "Captiva", "Silverado", "Spark", "Aveo"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Pickup", "Coupe"]
  },

  "Opel": {
    models: [
      "Corsa", "Astra", "Insignia", "Vectra", "Zafira", "Meriva",
      "Mokka", "Antara", "Frontera", "Combo", "Vivaro", "Movano",
      "Kadett", "Omega", "Calibra", "Tigra", "GT"
    ],
    popular: ["Corsa", "Astra", "Zafira", "Combo", "Mokka"],
    bodyTypes: ["Sedan", "Hatchback", "SUV", "Van", "Coupe"]
  }
};

// Utility functions for easy data manipulation
export const carDataUtils = {
  // Get all makes
  getAllMakes() {
    return Object.keys(eastAfricanCarData).map(make => ({
      id: make.toLowerCase().replace(/[\s-]/g, ''),
      name: make,
      slug: make.toLowerCase().replace(/[\s-]/g, '-'),
      modelCount: eastAfricanCarData[make].models.length
    }));
  },

  // Get models for a specific make
  getModelsForMake(makeName) {
    const make = eastAfricanCarData[makeName];
    if (!make) return [];
    
    return make.models.map(model => ({
      id: `${makeName.toLowerCase()}-${model.toLowerCase().replace(/[\s-]/g, '')}`,
      name: model,
      slug: `${makeName.toLowerCase()}-${model.toLowerCase().replace(/[\s-]/g, '-')}`,
      make: makeName,
      makeSlug: makeName.toLowerCase().replace(/[\s-]/g, '-')
    }));
  },

  // Get popular models for a make
  getPopularModelsForMake(makeName) {
    const make = eastAfricanCarData[makeName];
    if (!make || !make.popular) return [];
    
    return make.popular.map(model => ({
      id: `${makeName.toLowerCase()}-${model.toLowerCase().replace(/[\s-]/g, '')}`,
      name: model,
      slug: `${makeName.toLowerCase()}-${model.toLowerCase().replace(/[\s-]/g, '-')}`,
      make: makeName,
      makeSlug: makeName.toLowerCase().replace(/[\s-]/g, '-')
    }));
  },

  // Get all make-model combinations
  getAllMakeModels() {
    const makeModels = [];
    Object.keys(eastAfricanCarData).forEach(make => {
      eastAfricanCarData[make].models.forEach(model => {
        makeModels.push({
          id: `${make.toLowerCase()}-${model.toLowerCase().replace(/[\s-]/g, '')}`,
          name: `${make} ${model}`,
          slug: `${make.toLowerCase()}-${model.toLowerCase().replace(/[\s-]/g, '-')}`,
          make: make,
          model: model,
          makeSlug: make.toLowerCase().replace(/[\s-]/g, '-'),
          modelSlug: model.toLowerCase().replace(/[\s-]/g, '-')
        });
      });
    });
    return makeModels;
  },

  // Search makes and models
  searchMakeModels(query) {
    const allMakeModels = this.getAllMakeModels();
    return allMakeModels.filter(item => 
      item.name.toLowerCase().includes(query.toLowerCase()) ||
      item.make.toLowerCase().includes(query.toLowerCase()) ||
      item.model.toLowerCase().includes(query.toLowerCase())
    );
  },

  // Get body types for a make
  getBodyTypesForMake(makeName) {
    const make = eastAfricanCarData[makeName];
    return make ? make.bodyTypes : [];
  },

  // Add new make (for extensibility)
  addMake(makeName, makeData) {
    if (!eastAfricanCarData[makeName]) {
      eastAfricanCarData[makeName] = {
        models: makeData.models || [],
        popular: makeData.popular || [],
        bodyTypes: makeData.bodyTypes || []
      };
      return true;
    }
    return false; // Make already exists
  },

  // Add model to existing make
  addModelToMake(makeName, modelName) {
    if (eastAfricanCarData[makeName]) {
      if (!eastAfricanCarData[makeName].models.includes(modelName)) {
        eastAfricanCarData[makeName].models.push(modelName);
        return true;
      }
    }
    return false;
  },

  // Get statistics
  getStatistics() {
    const makes = Object.keys(eastAfricanCarData);
    const totalModels = makes.reduce((total, make) => 
      total + eastAfricanCarData[make].models.length, 0);
    
    return {
      totalMakes: makes.length,
      totalModels: totalModels,
      averageModelsPerMake: Math.round(totalModels / makes.length),
      makesList: makes
    };
  }
};

// Export default for easy importing
export default {
  data: eastAfricanCarData,
  utils: carDataUtils
};